import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shopping-bag-2",
  "use": "icon-shopping-bag-2-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-shopping-bag-2\"><path d=\"M25.333 9.333h-4V8a5.333 5.333 0 10-10.666 0v1.333h-4a1.333 1.333 0 00-1.334 1.334v14.666a4 4 0 004 4h13.334a4 4 0 004-4V10.667a1.333 1.333 0 00-1.334-1.334zM13.333 8a2.667 2.667 0 015.334 0v1.333h-5.334V8zM24 25.333a1.333 1.333 0 01-1.333 1.334H9.333A1.333 1.333 0 018 25.333V12h2.667v1.333a1.333 1.333 0 002.666 0V12h5.334v1.333a1.333 1.333 0 002.666 0V12H24v13.333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol